const NAME = "ISSUE_PERMISSIONS";

export default NAME;
